<input
  [(ngModel)]="value"
  class="c-form__input"
  type="date"
/>